import { getFormattedPrice } from "../../../../assets/js/get-formatted-price";

const OrderSummaryTotalRow = ({ label, priceNumber, isNegative = false }) => {
  return (
    <div
      className={`order-summary__row ${
        isNegative ? "order-summary__row--negative" : ""
      }`}
    >
      <div className="order-summary__row-inner">
        <span className="order-summary__label">{label}</span>
        <span className="order-summary__price">
          {isNegative ? "- " : ""}€ {getFormattedPrice(priceNumber)}
        </span>
      </div>
    </div>
  );
};

export { OrderSummaryTotalRow };
